<div class="header">
  <h3>{{ 'sideNav.notifications' | translate }}</h3>
  @if (isPauseAll) {
    <div id="pause-warning-message" class="simple-warning">
      <img src="../../../../assets/images/Warning.svg" alt="warning icon" />
      {{ 'notification.pauseAllNotifcationsWarning' | translate }}
    </div>
  }
  <button
    [ngClass]="isPauseAllDisabled() ? 'disabled-a' : ''"
    (click)="handlePauseClick()"
    tabindex="0"
    (keydown.enter)="handlePauseClick()"
    class="button button-green"
  >
    @if (!isPauseAll) {
      <span class="material-symbols-outlined">&#xe034;</span>
    }
    @if (isPauseAll) {
      <span class="material-symbols-outlined">&#xe037;</span>
    }
    {{ this.isPauseAll ? 'Unpause All' : 'Pause All' }}
  </button>
</div>

<app-table
  [tabs]="this.tabs"
  [activeTabId]="this.activeTabId"
  (tabChange)="changeActiveTable($event)"
></app-table>

<ng-template #pauseAllModal>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">{{ 'notification.pauseAllNotifcations' | translate }}</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
    </div>
    <div class="modal-body">
      <p>
        {{ 'notification.pauseMessage' | translate }}<br />{{
          'notification.confirmMessage' | translate
        }}
      </p>
    </div>
    <div class="modal-footer">
      <button type="button" class="button button-clear" (click)="closeModal()">
        {{ 'common.cancel' | translate }}
      </button>
      <button
        type="button"
        class="button button-pink"
        (click)="pauseUnpauseAllNotification('pause')"
      >
        {{ 'notification.pauseAll' | translate }}
      </button>
    </div>
  </div>
</ng-template>

<ng-template #unpauseAllModal>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">{{ 'notification.unpauseAllNotifications' | translate }}</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
    </div>
    <div class="modal-body">
      <p>
        {{ 'notification.unpauseMessage' | translate }}<br />{{
          'notification.confirmMessage' | translate
        }}
      </p>
    </div>
    <div class="modal-footer">
      <button type="button" class="button button-clear" (click)="closeModal()">
        {{ 'common.cancel' | translate }}
      </button>
      <button
        type="button"
        class="button button-pink"
        (click)="pauseUnpauseAllNotification('unpause')"
      >
        {{ 'notification.unpauseAll' | translate }}
      </button>
    </div>
  </div>
</ng-template>

<ng-template #noEmailsModal>
  <div class="modal-header">
    <h5 class="modal-title">{{ 'notification.noEmails' | translate }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
  </div>
  <div class="modal-body">
    <p>{{ 'notification.noEmailsMessage' | translate }}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="button button-clear" (click)="closeModal()">
      {{ 'common.cancel' | translate }}
    </button>
    <button type="button" class="button button-pink" (click)="openDistributionListModal()">
      {{ 'notification.addEmails' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #toggleCell let-row let-value="value" let-column>
  <label class="slider-with-text" (click)="$event.stopPropagation()">
    <span class="slider-background">{{ 'notification.inactive' | translate }}</span>
    <span class="enabled-overlay">{{ 'notification.active' | translate }}</span>
    <input
      [disabled]="isPauseAll"
      #statusToggle
      type="checkbox"
      id="status"
      [checked]="value === 'Active' || value === 'Paused'"
      (change)="toggleStatus(row, statusToggle)"
    />
  </label>
</ng-template>

<ng-template #templateCell let-row let-value="value" let-column>
  <button class="button button-clear button-table" (click)="viewTemplate($event)">
    {{ 'notification.viewEditTemplate' | translate }}
  </button>
</ng-template>
